{
  "auth": {
    "checkingSession": "Vérification de votre connexion..."
  },
  "authLayout": {
    "logoAlt": "Logo Constructions-3D"
  },
  "errors": {
    "accepted": "Le format de ce champ est invalide",
    "blank": "Ce champ ne peut pas être vide",
    "confirmation": "Ce champ doit correspondre au mot de passe",
    "empty": "Ce champ ne peut pas être vide",
    "equalTo": "Le format de ce champ est invalide",
    "even": "Le format de ce champ est invalide",
    "exclusion": "Le format de ce champ est invalide",
    "greaterThan": "Le format de ce champ est invalide",
    "greaterThanOrEqualTo": "Le format de ce champ est invalide",
    "in": "Le format de ce champ est invalide",
    "inclusion": "Le format de ce champ est invalide",
    "invalid": "Ce champ est invalide",
    "invalidCredentials": "Identifiants invalides",
    "invalidEmail": "Format d'email invalide",
    "lessThan": "Le format de ce champ est invalide",
    "lessThanOrEqualTo": "Le format de ce champ est invalide",
    "minLength": "Ce champ doit comporter au moins 8 caractères",
    "modelInvalid": "Le modèle de ce champ est invalide",
    "notAnInteger": "Ce champ doit être un nombre entier",
    "notANumber": "Ce champ doit être un nombre",
    "odd": "Le format de ce champ est invalide",
    "otherThan": "Le format de ce champ est invalide",
    "passwordsMatch": "Les mots de passe ne correspondent pas",
    "passwordSpecialChars": "Ce mot de passe doit contenir au moins un caractère spécial",
    "passwordTooLong": "Ce mot de passe est trop long",
    "passwordUppercase": "Ce mot de passe doit contenir au moins une majuscule",
    "present": "Le format de ce champ est invalide",
    "required": "Ce champ est requis",
    "sceneNotSaved": "Êtes-vous sûr de vouloir quitter ? Vos modifications récentes pourraient ne pas être enregistrées.",
    "taken": "Cette valeur est déjà utilisée",
    "tooLong": "Cette valeur est trop longue",
    "tooShort": "Cette valeur est trop courte",
    "unknown": "Une erreur inconnue s'est produite",
    "wrongLength": "Cette valeur n'a pas la bonne longueur"
  },
  "footer": {
    "copyright": {
      "rights": "Tous droits réservés.",
      "year": "Copyright © {{ year }} Constructions-3D."
    },
    "sections": {
      "contactUs": {
        "title": "Contactez-nous"
      },
      "legal": {
        "links": {
          "cookiePolicy": "Politique de cookies",
          "privacyPolicy": "Politique de confidentialité",
          "termsOfUse": "Conditions d'utilisation"
        },
        "title": "Informations légales"
      }
    },
    "theme": {
      "dark": "Foncé",
      "light": "Clair",
      "system": "Système"
    }
  },
  "forgotPassword": {
    "checkInbox": "Veuillez vérifier votre boîte de réception et suivre les instructions pour réinitialiser votre mot de passe.",
    "emailSent": "Un email de réinitialisation a été envoyé à",
    "links": {
      "signin": "Se connecter",
      "signup": "S'inscrire"
    },
    "metaTitle": "Réinitialisation de mot de passe · Printsite Studio",
    "submit": "Réinitialiser le mot de passe",
    "title": "Réinitialiser votre mot de passe"
  },
  "form": {
    "currentPasswordLabel": "Mot de passe actuel",
    "emailLabel": "Adresse email",
    "emailPlaceholder": "exemple@domaine.com",
    "hidePassword": "Cacher le mot de passe",
    "passwordConfirmationLabel": "Confirmation du mot de passe",
    "passwordLabel": "Mot de passe",
    "showPassword": "Afficher le mot de passe"
  },
  "globals": {
    "cancel": "Annuler",
    "machine": "Machine",
    "no": "Non",
    "save": "Enregistrer",
    "yes": "Oui"
  },
  "loading": "Chargement...",
  "navbar": {
    "documentation": {
      "tooltip": "Centre de documentation"
    },
    "dropdown": {
      "backToProjects": "Retour aux projets",
      "renameProject": "Renommer",
      "settings": "Mon compte",
      "shareProject": "Envoyer une copie",
      "signout": "Déconnexion"
    },
    "help": {
      "tooltip": "Demander de l'aide"
    },
    "searchPlaceholder": "Rechercher un projet...",
    "signIn": "Connexion",
    "signUp": "Inscription"
  },
  "project": {
    "back": "Retour aux projets",
    "camera": {
      "reset": "Remettre à zéro la caméra",
      "togglePerspective": "Changer la caméra {{type}}",
      "type": {
        "orthographic": "Projection orthographique [C]",
        "perspective": "Projection en perspective [C]"
      }
    },
    "created": "Créé par {{username}} le {{date}}",
    "emptyProjectModal": {
      "descriptions": {
        "maxiprinter": "Impression grand format",
        "miniprinter-l": "Impression compacte",
        "miniprinter-xl": "Impression compacte pour de plus grands projets"
      },
      "importFile": {
        "description": "Ajoutez un fichier sans choisir de machine",
        "title": "Importer un fichier"
      },
      "submit": "Continuer",
      "title": "Créer un nouveau projet"
    },
    "error": "Une erreur est survenue lors du chargement de ce projet. Veuillez réessayer plus tard.",
    "island": {
      "addPrinter": {
        "cancel": "Annuler le placement [Échap]",
        "tooltip": "Ajouter une {{label}}"
      },
      "default": "Sélection [Échap]",
      "rotate": "Rotation [R]",
      "translate": "Translation [G]"
    },
    "leftBar": {
      "files": {
        "contextMenu": {
          "assignTo": "Attribuer",
          "delete": "Supprimer",
          "focus": "Cadrer",
          "noPrinter": "Aucune machine",
          "rename": "Renommer",
          "split": "Découper par contour"
        },
        "emptyState": {
          "buttonLabel": "Ajouter un fichier",
          "subtitle": "Votre project n'a pas encore de fichier. Ajoutez-en un en cliquant sur le bouton ci-dessous.",
          "title": "Aucun fichier."
        }
      },
      "groups": {
        "contextMenu": {
          "delete": "Supprimer",
          "focus": "Cadrer",
          "rename": "Renommer"
        },
        "title": "Fichiers"
      },
      "printers": {
        "add": "Ajouter une machine (m)",
        "contextMenu": {
          "delete": "Supprimer",
          "focus": "Cadrer",
          "rename": "Renommer"
        },
        "emptyState": {
          "buttonLabel": "Ajouter une machine",
          "subtitle": "Votre project n'a pas encore de machine. Ajoutez-en une en cliquant sur le bouton ci-dessous.",
          "title": "Aucune machine."
        },
        "title": "Machines",
        "unassignedFiles": "Sous-fichiers non assignés",
        "upload": "Importer un fichier [Ctrl+I]"
      }
    },
    "loadingState": {
      "fileTooLarge": "Fichier trop volumineux (max 200 Mo)",
      "finalizingFile": "Finalisation de l'import...",
      "importingFile": "Import de vos fichiers en cours...",
      "loadingProject": "Chargement du projet en cours...",
      "parsingFile": "Analyse de la structure...",
      "processingFile": "Traitement de la géométrie...",
      "readingFile": "Lecture du fichier...",
      "savingProject": "Sauvegarde de votre projet en cours...",
      "uploadError": "Échec de l'import"
    },
    "metaTitle": "{{projectName}} · Printsite Studio",
    "modes": {
      "default": "Placement",
      "forbiddenZone": "Zones interdites",
      "seam": "Position de seam"
    },
    "name": "Nom",
    "navbar": {
      "save": {
        "save": "Enregistrer",
        "saving": "Enregistrement en cours..."
      }
    },
    "positioningAssistant": {
      "back": "Retour",
      "next": "Suivant",
      "steps": {
        "file": {
          "info": "1 fichier correspond à 1 jeu de coordonnées",
          "instruction": "Sélectionnez ou importez un fichier et un fichier CAO"
        },
        "introduction": {
          "description": "Aligne automatiquement les machines à partir des coordonnées CAO et des mesures réelles — sans réglage manuel.",
          "instructions1": "Importer le projet",
          "instructions2": "Ajouter les machines",
          "instructions3": {
            "description": "Importer le fichier CAO et les fichiers machines (.csv ou .dxf)",
            "details1": {
              "highlight": "1 fichier CAO",
              "text": " correspond à 1 jeu de coordonnées"
            },
            "details2": {
              "highlight": "Ajoutez des imprimantes",
              "text": " si besoin"
            },
            "details3": {
              "highlight": "détection automatique",
              "prefix": "Pas d'assignation manuelle : ",
              "suffix": " via G-code"
            }
          }
        },
        "machine": {
          "instruction": "Sélectionnez la machine et importez les coordonnées"
        },
        "resume": {
          "title": "Découvrez les résultats"
        }
      },
      "title": "Assistant de positionnement"
    },
    "rightBar": {
      "emptyState": {
        "subtitle": "Vous n'avez aucun élément sélectionné. Sélectionnez un élément en cliquant dessus dans l'espace de travail ou dans la liste des machines / fichiers dans la barre de gauche.",
        "title": "Aucun élément sélectionné."
      },
      "export": {
        "action": "Télécharger le Gcode"
      },
      "position": {
        "dropToFloor": "Poser au sol",
        "rotation": "Rotation",
        "title": "Position",
        "translation": "Translation"
      },
      "positioningAssistant": {
        "inputLabel": "Fichier CAO",
        "inputPlaceholder": "Fichier .csv ou .dxf",
        "run": "Lancer l'assistant de positionnement",
        "selectFile": "Sélectionnez un fichier...",
        "title": "Asst. de positionnement"
      },
      "preview": {
        "action": "Prévisualiser le Gcode",
        "pending": "Préparation de la preview..."
      },
      "multiSelection": {
        "description": "Assigner tous les fichiers sélectionnés à la même machine",
        "title": "{{count}} éléments sélectionnés"
      },
      "printerAssignment": {
        "description": "Assignation à une machine",
        "noPrinter": "Aucune machine",
        "title": "Assignation"
      },
      "printerSettings": {
        "options": {
          "head": "Tête d'impression",
          "head_1k": "1K",
          "head_2k": "2K"
        },
        "title": "Paramètres de la machine"
      },
      "printSettings": {
        "avoidInsideTravelling": "Empêcher les déplacements à l'intérieur du fichier",
        "avoidInsideTravellingMarginMm": "Dépassement (en mm)",
        "invertPrintDirection": "Inverser le sens d'impression",
        "layerHeight": "Hauteur des couches",
        "layersAmount": "Nombre de couches",
        "layersGroupAmount": "Nombre de couches par groupe",
        "layersGroupAmountTooltip": "Le nombre de couches par groupe permet de séquencer l'impression du fichier lors de l'impression",
        "spiralMode": "Mode d'impression",
        "spiralModes": {
          "off": "Normal",
          "semiSpiral": "Semi-spiralisé",
          "spiral": "Spiralisé"
        },
        "title": "Paramètres d'impression",
        "tooltip": "Configurez ici les paramètres d'impression de votre fichier",
        "totalHeight": "Hauteur totale"
      },
      "forbiddenZone": {
        "delete": "Supprimer la zone",
        "height": "Hauteur (mm)",
        "title": "Zone interdite"
      },
      "size": {
        "height": "Hauteur",
        "length": "Longueur",
        "title": "Taille",
        "width": "Largeur"
      },
      "zoneSettings": {
        "area": {
          "full": "Complète",
          "half": "Scindée",
          "none": "Aucune",
          "title": "Zone"
        },
        "grid": {
          "cartesian": "Cartésienne",
          "none": "Aucune",
          "polar": "Polaire",
          "title": "Grille"
        },
        "settings": {
          "boom": "Boom",
          "height": "Hauteur",
          "jib": "Jib",
          "title": "Configuration"
        },
        "title": "Zone de la machine",
        "zone": {
          "printable": "Imprimable",
          "reachable": "Atteignable",
          "title": "Type"
        }
      }
    },
    "savedTimeAgo": "Enregistré {{ timeAgo }}",
    "savedJustNow": "Enregistré à l'instant",
    "saving": "Enregistrement...",
    "shareModal": {
      "button": "Envoyer une copie du projet",
      "close": "Fermer",
      "instructions1": "Envoyez une copie de votre projet à un autre utilisateur en tapant son adresse e-mail dans le champ ci-dessous.",
      "instructions2": "Veillez à ce que cet utilisateur ait déjà un compte sur la plateforme.",
      "noteLabel": "Message (facultatif)",
      "notePlaceholder": "Ajoutez un message pour accompagner le projet…",
      "successMessage": "Une copie du projet a été envoyée à {{ userEmail }}.",
      "title": "Envoyer une copie du projet"
    },
    "updated": "Modifié le {{date}}",
    "zone": {
      "toggle": "Changer la zone",
      "toggleSlice": "Changer la zone {{type}}",
      "type": {
        "full": "complète",
        "sliced": "tranchée"
      }
    }
  },
  "projectPreview": {
    "backToEditor": "Retour à l'éditeur",
    "displayGcode": "Affichage du GCode",
    "errorState": {
      "retryButton": "Réessayer",
      "subtitle": "Une erreur est survenue lors de la génération de l'aperçu du gcode. Veuillez réessayer.",
      "title": "Impossible de charger l'aperçu du gcode"
    },
    "export": "Télécharger",
    "loadingState": {
      "buildingPreview": "Construction de l'aperçu…",
      "loadingGcode": "Découpe en cours..."
    },
    "metaTitle": "{{projectName}} · {{printerName}} · Printsite Studio",
    "navbar": {
      "downloadGcode": {
        "idle": "Télécharger le Gcode",
        "pending": "Téléchargement en cours..."
      }
    },
    "settings": {
      "displayG0": "Afficher les G0",
      "title": "Paramètres"
    },
    "statistics": {
      "form": {
        "layerWidth": "Largeur de couche (en mm)",
        "priceBigBag": "Prix du matériau (€ / big bag)",
        "printSpeed": "Vitesse d'impression (en mm/s)"
      },
      "freshMortarMass": {
        "kg": "kg",
        "label": "Masse de mortier frais",
        "t": "t"
      },
      "freshMortarVolume": {
        "label": "Volume de mortier frais",
        "m3": "m³"
      },
      "liftSpeed": {
        "cmh": "cm/h",
        "label": "Vitesse de levée moyenne"
      },
      "materialLength": {
        "label": "Longueur de l'impression",
        "m": "m"
      },
      "materialVolume": {
        "bigbag": "big bags"
      },
      "materialWeight": {
        "kg": "kg",
        "label": "Matière sèche requise",
        "t": "t"
      },
      "price": {
        "label": "Coût du projet"
      },
      "printingTime": {
        "hours": "h",
        "label": "Durée d'impression",
        "minutes": "m"
      },
      "title": "Statistiques",
      "waterVolume": {
        "l": "l",
        "label": "Volume d'eau"
      }
    }
  },
  "projects": {
    "emptyState": {
      "buttonLabel": "Créer un projet",
      "subtitle": "Vous n'avez pas encore créé de projet. Créez votre premier projet en cliquant sur le bouton ci-dessous.",
      "title": "Aucun projet."
    },
    "error": "Une erreur est survenue lors du chargement de vos projets. Veuillez réessayer plus tard.",
    "filters": {
      "dateCreated": "Date de création",
      "lastModified": "Dernière modification",
      "name": "Nom"
    },
    "layouts": {
      "grid": "Vue en grille",
      "list": "Vue en liste"
    },
    "metaTitle": "Projets · Printsite Studio",
    "new": "Nouveau projet",
    "noProjects": "Vous n'avez pas encore de projets. Créez votre premier projet pour commencer !",
    "project": {
      "edited": "Modifié {{editedAt}}"
    },
    "sortBy": "Trier par :",
    "title": "Mes projets"
  },
  "resetPassword": {
    "invalidToken": "Ce lien de réinitialisation de mot de passe est invalide ou a expiré. Veuillez demander un nouveau lien de réinitialisation.",
    "links": {
      "signin": "Se connecter",
      "signup": "S'inscrire"
    },
    "metaTitle": "Nouveau mot de passe · Printsite Studio",
    "submit": "Changer le mot de passe",
    "success": "Votre mot de passe a été changé avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "title": "Créer un nouveau mot de passe"
  },
  "settings": {
    "metaTitle": "Paramètres",
    "signOut": {
      "button": "Se déconnecter",
      "description": "Me déconnecter de mon compte",
      "explanation": "Vous pouvez vous déconnecter en cliquant sur le bouton ci-dessous.",
      "title": "Déconnexion"
    },
    "title": "Paramètres"
  },
  "signin": {
    "links": {
      "extras": {
        "noAccount": "Vous n'avez pas encore de compte ?"
      },
      "forgotPassword": "Mot de passe oublié ?",
      "signup": "S'inscrire"
    },
    "metaTitle": "Connexion · Printsite Studio",
    "signInWithC3D": "Connexion avec Constructions-3D",
    "title": "Connexion à Printsite Studio"
  },
  "signup": {
    "links": {
      "extras": {
        "alreadySignedUp": "Vous avez déjà un compte ?"
      },
      "signin": "Se connecter"
    },
    "metaTitle": "Inscription · Printsite Studio",
    "submit": "S'inscrire",
    "title": "Inscription à Printsite Studio"
  },
  "testEnvBanner": {
    "message": "Vous êtes dans l'environnement de {{ env }}"
  }
}
